<template>
  <BaseModal size="md" :is-open="isOpen">
    <template #header>
      <NavBar>
        <template #center>
          <span class="navbar-header">Perda de progresso</span>
        </template>
      </NavBar>
    </template>
    <template #content>
      <div class="content">
        <BaseText as="p" size="lg"> Sair do construtor? </BaseText>
        <BaseText as="p" size="lg"> O seu progresso será perdido. </BaseText>
      </div>
    </template>

    <template #footer>
      <ModalFooterWallet
        left-button-label="Voltar"
        right-button-label="Sair do construtor"
        @left-button-clicked="closeModal"
        @right-button-clicked="confirm"
      />
    </template>
  </BaseModal>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit, Inject } from 'vue-property-decorator';
import { ModalFooterWallet } from '@/modules/wallet-builder/src/components/Modals/ModalFooter';
import { NavBar, BaseModal, BaseText } from '@warrenbrasil/nebraska-web';

import { GtmTracker } from '@/modules/common/services/analytics';

@Component({
  components: {
    BaseModal,
    ModalFooterWallet,
    NavBar,
    BaseText
  }
})
export default class PreventUnsavedChangesModal extends Vue {
  @Prop({ type: Boolean, required: true })
  public isOpen!: boolean;

  @Inject('resetWallet')
  private resetWallet!: Function;

  private trackEvent(action: string) {
    GtmTracker.trackEvent({
      category: 'PEX - Carteira Editada',
      action: `Sair ${action}`,
      label: 'B2C'
    });
  }

  @Emit('close-prevent-unsaved-changes-modal')
  public closeModal() {
    this.trackEvent('- Cancelar');
  }

  @Emit('confirm-prevent-unsaved-changes-modal')
  public confirm() {
    this.resetWallet();
    this.trackEvent('- Confirmar');
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: @size-spacing-x800;
  text-align: center;
}
</style>
